import React from "react";
import { MoreVertical } from "lucide-react";
import {
  Menubar,
  MenubarContent,
  MenubarItem,
  MenubarMenu,
  MenubarTrigger,
} from "@/components/ui";
import { useDataTableContext } from "../Context/DataTableContext";
import { useTranslation } from "react-i18next";
export interface ActionItem {
  key: string;
  render: () => React.ReactNode;
  onClick: () => void;
}

interface HeaderActionsProps {
  actions: ActionItem[];
  className?: string;
}

export function HeaderActionsComponent({
  actions,
  className,
}: HeaderActionsProps) {
  const { table } = useDataTableContext();
  const { t } = useTranslation();
  const disabled = table?.getPageCount() === 0;

  return (
    <Menubar
      role="menubar"
      aria-label={t("dataTable.tableActions")}
      className={`h-8 w-8 items-center justify-center ${className} ${
        disabled
          ? "pointer-events-none cursor-not-allowed text-primary-extra-light opacity-50"
          : "cursor-pointer hover:bg-muted"
      }`}
    >
      <MenubarMenu>
        <MenubarTrigger
          role="menuitem"
          aria-label={t("dataTable.openTableActionsMenu")}
          aria-haspopup="true"
          aria-expanded="false"
          aria-disabled={disabled}
          className="p-0"
        >
          <MoreVertical className="h-4 w-4" aria-hidden="true" />
        </MenubarTrigger>
        <MenubarContent
          align="end"
          className="w-[200px]"
          role="menu"
          data-testid="table-actions-menu"
          aria-label={t("dataTable.tableActions")}
          aria-orientation="vertical"
        >
          {actions.map((action) => (
            <MenubarItem
              key={action.key}
              onClick={action.onClick}
              className="flex cursor-pointer items-center"
              role="menuitem"
              aria-label={action.key}
              tabIndex={0}
            >
              {action.render()}
            </MenubarItem>
          ))}
        </MenubarContent>
      </MenubarMenu>
    </Menubar>
  );
}
